var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.62 44C6.265 44 0 35.82 0 21.927 0 8.063 6.323 0 16.62 0c10.267 0 16.62 8.063 16.62 21.956C33.24 35.792 26.973 44 16.62 44zm0-7.135c4.814 0 7.744-5.134 7.744-14.938 0-9.745-2.959-14.763-7.744-14.763-4.757 0-7.745 5.047-7.745 14.763 0 9.775 2.959 14.938 7.745 14.938zM51.31 42.927V9.6h-.523L40.52 16.678v-8.15l10.82-7.455h8.73v41.854h-8.76z",
    fill: "#F2F1ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.d715b2ee9046c33c235f700d9df875bb.svg";
export { ForwardRef as ReactComponent };